import styled from 'styled-components';
import { rem, themed } from '@/shared/ui/core';

export const MenuWrapper = styled.div`
  position: relative;
`;

export const MenuButton = styled.button.attrs({
  type: 'button',
})`
  background: transparent;
  border: none;
  color: ${themed('primary.accent')};
  cursor: pointer;
  font-size: ${rem(14)};
  height: ${rem(19)};
  line-height: ${rem(19)};

  svg {
    fill: ${themed('primary.accent')};
    margin-left: ${rem(4)};
    height: ${rem(9)};
    width: ${rem(9)};
  }
`;

export const MenuItems = styled.ul`
  background: ${themed('primary.background')};
  border: 1px solid ${themed('common.borderColor')};
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.25);
  margin: 0;
  min-width: ${rem(90)};
  padding: 0.5rem 0;
  position: absolute;
  right: 0;
  z-index: 2;

  li {
    list-style: none;
    margin: 0;
    width: 100%;
  }
`;

export const MenuItem = styled.button.attrs({
  type: 'button',
})`
  background: transparent;
  border: none;
  color: ${themed('primary.accent')};
  cursor: pointer;
  font-size: ${rem(14)};
  padding: 0.5rem 1rem;
  text-align: left;
  width: 100%;

  font-weight: ${({ $selected }) => $selected ? 600 : 400};
`;
